import type { FC, SVGProps } from 'react';

export const AntennaIcon: FC<SVGProps<SVGSVGElement>> = props => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M11.25 8.5h1.5V22h-1.5z' fill='currentColor' />
    <circle cx='12' cy='7' r='1.5' fill='currentColor' />
    <path
      d='M9 5.5a3.5 3.5 0 0 0 0 4.5'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      d='M15 5.5a3.5 3.5 0 0 1 0 4.5'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path d='M6.5 3a6 6 0 0 0 0 9' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
    <path d='M17.5 3a6 6 0 0 1 0 9' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
  </svg>
);
